'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _serializeSignatureRequest = require('./serialize-signature-request');

var _serializeSignatureRequest2 = _interopRequireDefault(_serializeSignatureRequest);

var _mapHttpOperation = require('common/utils/map-http-operation');

var _mapHttpOperation2 = _interopRequireDefault(_mapHttpOperation);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//TODO - break these endpoints out to separate files

/**
* API Mappings. These are typically used in ../routes/index.js
*/

function makeUrl(uri) {
    var prefix = '';
    if (document.location && document.location.href.indexOf('/webapp_dev.php') > 0) {
        prefix = '/webapp_dev.php';
    }
    return prefix + _hfReactHelper2['default'].attachSessionInfoToUrl(uri);
}

function deserializeAPIResponseText(serialized) {
    var deserialized = {};
    if (serialized) {
        try {
            deserialized = JSON.parse(serialized.text);
            if (deserialized.data) {
                deserialized = deserialized.data;
            }
        } catch (e) {
            console.log('Error parsing JSON response', e);
        }
    }
    return deserialized;
}

/**
* Defines the various backend APIs/endpoints that get called via XHR in the app
*/

exports['default'] = {
    create: function create(app) {

        return {

            /**
            * Signature object
            */

            // TODO: Convert insert to use new superagent helper and remove superagent require from this file

            signature: {

                insert: function insert(op) {
                    return new Promise(function (resolve, reject) {

                        var model = op.target;
                        var url = makeUrl('/signature/upload');

                        if (model.file) {
                            _superagent2['default'].post(url).attach('qq_file', model.file, model.file.name).field('create_type_code', model.createType).field('type_code', model.type).end(function (err, data) {
                                if (err) {
                                    return reject(err);
                                } else {
                                    model.file = void 0;
                                }
                                resolve(deserializeAPIResponseText(data));
                            });

                            return;
                        }

                        var body = _qs2['default'].stringify({
                            'create_type_code': model.createType,
                            'type_code': model.type,
                            'data': model.signature,
                            'ux_version': 2
                        });

                        _superagent2['default'].post(url).send(body).end(function (err, data) {
                            resolve(deserializeAPIResponseText(data));
                        });
                    });
                },

                remove: function remove(op) {
                    return (0, _mapHttpOperation2['default'])({
                        'url': makeUrl('/signature/remove'),
                        'method': 'POST',
                        'query': {
                            'guid': op.target.guid,
                            'ux_version': 2
                        },
                        transformResponse: function transformResponse() {
                            // API doesn't give anything useful - return a blank object - this
                            // will get ignored by the model calling it (CC)
                            return Promise.resolve({});
                        }
                    });
                },

                rotate: function rotate(op) {
                    return {
                        'url': makeUrl('/signature/rotate'),
                        'method': 'POST',
                        'query': {
                            'guid': op.target.guid,
                            'ux_version': 2
                        }
                    };
                },

                markAsPrimary: function markAsPrimary(op) {
                    return {
                        'url': makeUrl('/signature/markAsPrimary'),
                        'method': 'POST',
                        'query': {
                            'guid': op.target.guid,
                            'ux_version': 2
                        }
                    };
                },

                edit: function edit(op) {

                    var model = op.target;
                    var url = makeUrl('/signature/upload');
                    var type = model.type || 'S';

                    return {
                        'url': makeUrl('/signature/upload'),
                        'method': 'POST',
                        'data': _qs2['default'].stringify({
                            'is_edit': true,
                            'guid': model.guid,
                            'create_type_code': model.createType,
                            'type_code': type,
                            'data': model.getEditParams(),
                            'ux_version': 2
                        })
                    };
                },

                checkEmailSignatureStatus: function checkEmailSignatureStatus(op) {

                    var model = op.target;

                    return {
                        'url': makeUrl('/signature/emailSignatureStatus'),
                        'method': 'POST',
                        'query': {
                            'email_guid': model.emailGuid,
                            'ux_version': 2
                        }
                    };
                }
            },

            /**
            * Signature collection
            */

            signatures: {

                load: function load(op) {
                    var type = op.target.type;
                    return {
                        'url': makeUrl('/signature/list'),
                        'method': 'GET',
                        'query': {
                            'type_code': type,
                            'ux_version': 2
                        }
                    };
                }
            },

            /**
            */

            signatureRequest: {

                load: function load(op) {
                    var model = op.target;

                    return {
                        'url': makeUrl('/signer/load'),
                        'method': 'GET',
                        'query': {
                            'guid': model.guid,
                            'access_code': model.accessCode,
                            'signature_id': model.embeddedData.signatureId,
                            'selected_signer': model.selectedSigner || void 0,
                            'tsm_guid': model.transmissionGuid || void 0,
                            'status_token': app.statusToken
                        }
                    };
                },

                update: function update(op) {

                    var model = op.target;
                    var data = model.toData();

                    data = (0, _serializeSignatureRequest2['default'])(data);

                    return (0, _mapHttpOperation2['default'])({
                        'url': makeUrl('/signer/save'),
                        'method': 'POST',
                        'data': {
                            'guid': data.guid,
                            'data': JSON.stringify(data.data)
                        },
                        transformResponse: function transformResponse() {
                            // API doesn't give anything useful - return a blank object - this
                            // will get ignored by the model calling it (CC)
                            return Promise.resolve({});
                        }
                    });
                },

                getSignatureRequestProgress: function getSignatureRequestProgress(op) {

                    return {
                        'url': makeUrl('/signer/ready'),
                        'method': 'GET',
                        'query': {
                            'tsm_guid': op.transmissionGuid,
                            'token': app.statusToken
                        }
                    };
                },

                complete: function complete(op) {

                    var model = op.target;
                    var data = model.toData();

                    data = (0, _serializeSignatureRequest2['default'])(data);

                    return (0, _mapHttpOperation2['default'])({
                        'url': makeUrl('/signer/finalize'),
                        'method': 'POST',
                        'query': {
                            'tsm_guid': model.transmissionGuid,
                            'access_code': model.accessCode
                        },
                        'data': {
                            'data': JSON.stringify(data.data)
                        },
                        transformResponse: function transformResponse(ret) {

                            if (ret.is_valid === false) {

                                // If fields are missing, they'll be returned in the error map
                                // listed as components
                                var fieldsMissing = ret.error_msg_map && Object.keys(ret.error_msg_map).filter(function (key) {
                                    return key.indexOf('component') !== -1;
                                }).length;

                                var errorType = fieldsMissing ? 'error.field.fieldsMissing' : 'error.general.message';
                                return Promise.reject(new Error(errorType));
                            }

                            return Promise.resolve(ret);
                        }
                    });
                }
            }
        };
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/api/endpoints/index.js
 ** module id = 581
 ** module chunks = 0
 **/